import MailingTemplate from './model.js'
import { deepGet, addToCollection } from '../shared/helper'

export default {
  namespaced: true,
  state: {
    mailingTemplates: [],
    filteredCollection: [],
    customerCollection: [],
    accountCollection: [],
    typeCollection: [],
    current: new MailingTemplate(),
    currentCustomer: null,
  },
  getters: {
    getCollection: state => state.mailingTemplates,
    getFilteredCollection: state => state.filteredCollection,
    getById: state => (id) => state.mailingTemplates.find(mailingTemplate => mailingTemplate.id === id),
    getCurrent: state => state.current,
    getCustomerCollection: state => state.customerCollection,
    getAccountCollection: state => state.accountCollection,
    getTypeCollection: state => state.typeCollection,
    getCurrentCustomer: state => state.currentCustomer,
  },
  actions: {
    getCollection({ commit, getters, state }, payload) {
      return this.dispatch('get', {
        path: 'v1/mailingTemplates',
        ...payload
      }).then((res) => {

        const data = deepGet(res, 'body.data')
        if (data) {

          const models = data.map((mailingTemplate) => {
            commit('addMailingTemplateToCollection', { mailingTemplateData: mailingTemplate })
            return getters.getById(mailingTemplate.id)
          })

          commit('addMailingTemplateToFilteredCollection', models)

          return { data: models, meta: res.body.meta }
        }
        return res
      })
    },
    getSingleMailingTemplate({ commit, getters }, payload) {
      return this.dispatch('get', {
        path: 'v1/mailingTemplates/' + payload.id
      }).then((res) => {
        const data = deepGet(res, 'body.data')
        if (data) {
          commit('addMailingTemplateToCollection', { mailingTemplateData: data })
          const mailingTemplate = getters.getById(data.id)
          commit('setCurrent', mailingTemplate)
          return mailingTemplate
        }
        return res
      })
    },
    getCustomerCollection ({ commit }, payload) {
      const id = payload.id
      delete payload.id
      return this.dispatch('get', {
        path: 'v1/mailingTemplates/' + id + '/customers',
        ...payload
      }).then((res) => {
        commit('updateCustomerCollection', res && res.body)
        return res && res.body
      })
    },
    getAccountCollection ({ state, commit }, payload) {
      if (!state.currentCustomer) {
        throw Error('missing current customer')
      }
      const id = payload.id
      delete payload.id
      return this.dispatch('get', {
        path: `v1/mailingTemplates/${id}/customers/${state.currentCustomer.id}/accounts`,
        ...payload
      }).then((res) => {
        commit('updateAccountCollection', res && res.body)
        return res && res.body
      })
    },
    getAllMailingTypes ({ commit }) {
      return this.dispatch('get', {
        path: 'v1/mailingTypes/',
      }).then((res) => {
        const data = deepGet(res, 'body.data')
        commit('updateTypeCollection', res && res.body)
        return data
      })
    },
    update({ commit, getters }, model) {
      return this.dispatch('put', {
        path: 'v1/mailingTemplates/' + model.id,
        data: model.getJSON()
      }).then((res) => {

        commit('addMailingTemplateToCollection', { mailingTemplateData: res.body && res.body.data })

        return getters.getById(res.body && res.body.data.id)
      })
    },
    updateCustomerAccount ({ state, commit }, payload) {
      if (!state.currentCustomer) {
        throw Error('missing current customer')
      }
      return this.dispatch('put', {
        path: `v1/mailingTemplates/${payload.id}/customers/${state.currentCustomer.id}/accounts`,
        data: payload
      })
    },
    delete({ commit }, id) {
      return this.dispatch('del', {
        path: 'v1/mailingTemplates/' + id
      }).then((res) => {

        commit('removeMailingTemplateFromCollection', id)

        return res
      })
    }
  },
  mutations: {
    addMailingTemplateToCollection(state, { mailingTemplateData, opts }) {
      addToCollection(this, state.mailingTemplates, mailingTemplateData, MailingTemplate, opts)
    },
    addMailingTemplateToFilteredCollection(state, data) {
      state.filteredCollection = state.filteredCollection.concat(data)
    },
    removeMailingTemplateFromCollection(state, mailingTemplateId) {
      const index = state.mailingTemplates.findIndex(el => el.id === mailingTemplateId)

      if (index === -1) {
        console.warn(`Could not find/delete mailingTemplate ${mailingTemplateId}`)
        return
      }

      state.mailingTemplates.splice(index, 1)
    },
    clearCollection(state) {
      state.mailingTemplates = []
    },
    clearFilteredCollection(state) {
      state.filteredCollection = []
    },
    clearCustomerCollection(state) {
      state.customerCollection = []
    },
    clearAccountCollection(state) {
      state.accountCollection = []
    },
    updateAccountCollection (state, account) {
      state.accountCollection = state.accountCollection.concat(account.data)
    },
    updateCustomerCollection (state, customers) {
      state.customerCollection = state.customerCollection.concat(customers.data)
    },
    updateTypeCollection (state, types) {
      state.typeCollection = types.data
    },
    setCurrent (state, template) {
      state.current = template
    },
    setCurrentCustomer (state, customer) {
      state.currentCustomer = customer
    },
    resetCurrent (state) {
      state.currentTemplate = new MailingTemplate()
    },
    resetCurrentCustomer (state) {
      state.currentCustomer = null
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mailingTemplate/store.js